import { AfterViewInit } from '@angular/core';
import { ModalConfig } from '../../../model/modal-config';
import { PageNames } from '../../../shared/page-names.enum';
import { Emitter } from '../../../shared/utils/emitter/emitter';
import { EmitterConstants } from '../../../shared/emitter-constants';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { OmapiIdConstants } from '../../../shared/omapi-id-constants';
import { ImageUtils } from '../../../shared/utils/image/image-utils';
var TrialSuccessModalComponent = /** @class */ (function () {
    function TrialSuccessModalComponent(navigationService) {
        this.navigationService = navigationService;
        this.componentName = PageNames.TRIAL_SUCCESS_MODAL;
    }
    Object.defineProperty(TrialSuccessModalComponent.prototype, "logoUrl", {
        get: function () {
            return ImageUtils.getLogoUrlForOmapiId(this.omapiId);
        },
        enumerable: true,
        configurable: true
    });
    TrialSuccessModalComponent.prototype.backPressed = function () {
        Emitter.of(EmitterConstants.BACK_PRESSED).emit({ componentName: this.componentName, omapiId: this.trialOmapiId });
    };
    TrialSuccessModalComponent.prototype.trialName = function () {
        return OmapiIdConstants.PRODUCT_NAME_MAP.get(this.trialOmapiId);
    };
    TrialSuccessModalComponent.prototype.ngAfterViewInit = function () {
        this.navigationService.resetNavigation();
    };
    return TrialSuccessModalComponent;
}());
export { TrialSuccessModalComponent };
